import {Button, Card, CardBody, CardFooter, CardHeader, Input, Typography} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {loginService} from "../services/user/login";
import authManager from "../helper/AuthHelper";
import Validator from "../helper/validator/Validator";
import {Toaster} from "../helper/Toaster";
import PasswordField from "../components/system/passwordField";
import {ValidatorProvider} from "../helper/validator/ValidatorContext";
import {checkAll} from "../helper/validator/Check";
import {toast} from "react-toastify";

const Login = () => {
  const backgroundPhoto = '/assets/login-background.jpeg';
  const [loggedIn, setLoggedIn] = useState(true);
  const [isChecked, setIsChecked] = useState(false)
  const [validationErrors, setValidationErrors] = useState({
    mobile: '',
    password: ''
  });

  useEffect(() => {
    let is_logged_in = false;
    if (localStorage.getItem('userInfo') && localStorage.getItem('expiration') && localStorage.getItem('token')) {
      const expiration = new Date(localStorage.getItem('expiration'));
      const now = new Date();
      if (now < expiration) {
        is_logged_in = true
      } else {
        localStorage.clear();
      }
      window.location.href = "/loading";
      if (localStorage.getItem('defaultItem')) {
        localStorage.setItem('lastClicked', localStorage.getItem('defaultItem'));
        localStorage.removeItem('defaultItem');
      }
    }

    setLoggedIn(is_logged_in);
  }, []);

  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");

  // Helper function to validate individual fields
  const validateField = (value, rules) => {
    const ruleArray = rules.split("|");
    for (let rule of ruleArray) {
      if (rule === "required" && (!value || value.trim() === "")) {
        return "این فیلد الزامی است";
      }
      if (rule === "mobile") {
        const mobileRegex = /^09[0-9]{9}$/;
        if (!mobileRegex.test(value)) {
          return "شماره موبایل معتبر نیست (مثال: 09123456789)";
        }
      }
    }
    return "";
  };

  const submit = async (event) => {
    event.preventDefault();
    setIsChecked(true);
    
    // Validate all fields
    const mobileError = validateField(mobile, "required|mobile");
    const passwordError = validateField(password, "required");
    
    const newErrors = {
      mobile: mobileError,
      password: passwordError
    };
    
    setValidationErrors(newErrors);
    
    // Check if there are any errors
    const hasErrors = mobileError || passwordError;
    
    if (hasErrors) {
      // Show specific error messages
      if (mobileError) {
        toast.error(mobileError);
      } else if (passwordError) {
        toast.error(passwordError);
      }
      return;
    }

    // Also use checkAll for additional validation if needed
    const res = checkAll();
    if (!res) {
      toast.error("لطفا اطلاعات را به درستی وارد کنید");
      return;
    }

    const data = {
      phone: mobile,
      password
    };
    if (localStorage.getItem('lastClicked')) {
      data.role_id = 3
    }

    const result = await loginService(data);

    if (result.status === 202) {
      authManager.loginHandler(result.data)
      window.location.href = "/";
    } else if (result.status === 403) {
      Toaster.failure(null, "نام کاربری یا رمز ورود اشتباه است")
    }
  };

  // Handle input changes and clear validation errors
  const handleMobileChange = (e) => {
    setMobile(e.target.value);
    if (validationErrors.mobile) {
      setValidationErrors(prev => ({...prev, mobile: ''}));
    }
  };

  const handlePasswordChange = (value) => {
    setPassword(value);
    if (validationErrors.password) {
      setValidationErrors(prev => ({...prev, password: ''}));
    }
  };

  if (!loggedIn) {
    return (
      <ValidatorProvider>
        <form
          onSubmit={submit}
          className={"flex justify-center items-center h-screen"}
          style={{backgroundImage: `url(${backgroundPhoto})`}}
        >
          <div className="absolute inset-0 bg-black opacity-50 "></div>
          <Card className="flex w-full mx-4 md:w-2/3">
            <CardHeader variant="gradient" color="gray" className="mb-4 pt-4 grid place-items-center">
              <Typography variant="h3" color="white" className="pt-4 mb-4 text-center">
                پلتفرم جامع مشاوره و خدمات کسب و کار
              </Typography>
            </CardHeader>
            <CardBody className="flex flex-col gap-4 py-8 px-4">
              <div>
                <Input 
                  variant="static" 
                  value={mobile} 
                  label="شماره همراه *" 
                  placeholder="شماره همراه" 
                  size="lg"
                  onChange={handleMobileChange}
                  error={!!validationErrors.mobile}
                />
                <Validator isChecked={isChecked} state={mobile} rules="required|mobile"/>
              </div>
              
              <div >
                <PasswordField 
                  variant="static" 
                  type="password" 
                  label="رمز عبور *" 
                  placeholder="رمز عبور" 
                  size="lg"
                  onChange={handlePasswordChange}
                  error={!!validationErrors.password}
                />
                <Validator isChecked={isChecked} state={password} rules="required"/>
              </div>
            </CardBody>
            <CardFooter className="pt-0">
              <Button type="submit" variant="gradient" fullWidth className="mb-4">
                ورود
              </Button>
              <Typography variant="small" className="mt-6 flex justify-center">
                قبلا ثبت‌نام نکرده‌اید؟
                <Typography as="a" href="/register" variant="small" color="blue-gray" className="mx-2 font-bold">
                  ثبت نام
                </Typography>
              </Typography>
              <Typography variant="small" className="mt-6 flex justify-center">
                رمز خود را فراموش کرده‌اید؟
                <Typography as="a" href="/forgot_password" variant="small" color="blue-gray" className="mx-2 font-bold">
                  بازنشانی رمز عبور
                </Typography>
              </Typography>
              <Typography as="a" href="https://mymobasher.com" variant="small"
                          className="mt-6 flex justify-center font-bold"
                          color="blue-gray">
                بازگشت به سایت
              </Typography>
            </CardFooter>
          </Card>
        </form>
      </ValidatorProvider>
    );
  }
};

export default Login;
